import {createSlice} from "@reduxjs/toolkit"
import type {PayloadAction} from '@reduxjs/toolkit'

export interface SelectedModuleState {
  value: string
}

const initialState: SelectedModuleState = {
  value: sessionStorage.getItem("moduleSelected") == undefined ? "IN" : sessionStorage.getItem("moduleSelected") as string
}

export const selectedModuleSlice = createSlice({
  name: 'selectedModule',
  initialState,
  reducers: {
    selectedModule: (state, action: PayloadAction<string>) => {
      state.value = action.payload
    },
  },
})

export const {selectedModule} = selectedModuleSlice.actions
export default selectedModuleSlice.reducer
